<nav class="app-menu">
  <header class="app-menu__header">
    <span class="app-menu__avatar">{{ userInitial }}</span>
    <div class="app-menu__user">
      <strong>{{ fullName }}</strong>
      <small>{{ companyName }}</small>
    </div>
    <button type="button" class="app-menu__close" aria-label="بستن منو" (click)="close()">
      <i class="fa fa-times"></i>
    </button>
  </header>

  <ul class="app-menu__list">
    <ng-container *ngTemplateOutlet="tree; context: { $implicit: menu, depth: 0 }"></ng-container>
  </ul>
</nav>

<ng-template #tree let-nodes let-depth="depth">
  <li *ngFor="let node of nodes" class="menu-item" [class.is-open]="isOpen(node, depth)">
    <ng-container [ngSwitch]="node.kind">
      <ng-container *ngSwitchCase="'group'">
        <button type="button" class="menu-link menu-link--group" [attr.aria-expanded]="isOpen(node, depth)" (click)="toggle(node, depth)">
          <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
          <i class="fa fa-angle-down menu-link__chevron"></i>
        </button>
        <ul *ngIf="isOpen(node, depth)" class="menu-sub">
          <ng-container *ngTemplateOutlet="tree; context: { $implicit: node.children, depth: depth + 1 }"></ng-container>
        </ul>
      </ng-container>

      <a *ngSwitchCase="'route'" class="menu-link" [routerLink]="node.route" [target]="node.newTab ? '_blank' : '_self'" [attr.title]="node.hint">
        <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
      </a>

      <a *ngSwitchCase="'href'" class="menu-link" [href]="node.href" target="_blank" rel="noopener" [attr.title]="node.hint">
        <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
      </a>

      <button *ngSwitchCase="'action'" type="button" class="menu-link" [attr.title]="node.hint" (click)="node.action()">
        <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
      </button>

      <span *ngSwitchDefault class="menu-link is-inert">
        <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
      </span>
    </ng-container>
  </li>
</ng-template>

<ng-template #label let-node>
  <i *ngIf="node.icon" class="menu-link__icon fa" [ngClass]="node.icon"></i>
  <span class="menu-link__title">{{ node.title }}</span>
</ng-template>

<!-- رزرو تاکسی شهری / بین‌شهری -->
<taxi-manage *ngIf="isTaxiReservationOpen" [isOpenModal]="true" [isCity]="isCityTaxi" (onClose)="closeTaxiReservation()"></taxi-manage>
